import React from "react";
import styled from "@emotion/styled";
import { surface } from "@atlas-int/tokens";

export interface NoticeOverlayProps {
  visible: boolean;
  children: React.ReactNode;
  backgroundColor?: string;
  className?: string;
  /** Inset from parent edges in px (defaults to 0) */
  inset?: number;
}

const Overlay = styled.div<{ $bgColor: string; $inset: number }>`
  position: absolute;
  display: flex;
  top: ${({ $inset }) => $inset}px;
  right: ${({ $inset }) => $inset}px;
  bottom: ${({ $inset }) => $inset}px;
  left: ${({ $inset }) => $inset}px;
  background-color: ${({ $bgColor }) => $bgColor};
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  font-style: italic;
`;

const NoticeOverlay = React.memo<NoticeOverlayProps>(
  ({ visible, children, backgroundColor, className, inset = 0 }) => {
    if (!visible) return null;

    return (
      <Overlay
        $bgColor={backgroundColor ?? surface.muted}
        $inset={inset}
        className={className}
        onMouseMove={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </Overlay>
    );
  },
);

NoticeOverlay.displayName = "NoticeOverlay";

export default NoticeOverlay;
